import './Hero.css';

export default function Hero() {
  return (
    <section className="hero-wrapper d-flex align-items-center">
      <div className="container">
        <div className="row gy-5">

          {/* LEFT CONTENT */}
  <div className="col-lg-6">
    <h1 className="hero-title mb-4 lh-sm text-start">
      Build Smart Digital Solutions <span>That Grow</span><br />
      <span>Your Business</span>
    </h1>

    <p className="hero-subtitle mb-4 lh-lg">
      Web Development • Software Solutions <br />
      Custom IT Services for Modern Businesses
    </p>

    <div className="d-flex gap-3 flex-wrap">
      <a href="#" className="btn btn-primary btn-lg rounded-pill px-4">
        Get Started
      </a>
      <a href="#" className="btn btn-outline-light btn-lg rounded-pill px-4">
        Contact Us
      </a>
    </div>

    <div className="text-light mt-3">
      <h6 className="mb-0 cbadges">
        ⭐ Trusted by Clients &nbsp; 🏆 5+ Years Experience
      </h6>
    </div>
  </div>


          {/* RIGHT ILLUSTRATION */}
          <div className="col-lg-6 text-center">
            
              <img
                  src="/graphics/images/heroimage.svg"
                  alt="Software Development"
                  className="service-icon"
              />

          </div>

        </div>
      </div>
    </section>
  );
}
